module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"latest_sodium_meld_calculation_heading":"SMC Score","smc_score_field":"SMC Score","smc_score_source_field":"SMC Score Source"},"fr":{"latest_sodium_meld_calculation_heading":"Pointage MELD","smc_score_field":"Pointage MELD","smc_score_source_field":"Provenance du pointage"}}')
  delete Component.options._Ctor
}
